import React, { memo } from 'react';

interface IProps {
    content: string;
    objEllipsis?: any;
}

export function TruncateText({ content, objEllipsis = {} }: IProps) {
    const obj = Object.assign(
        {},
        {
            line: 2,
            sizeText: '1.4rem',
            fontWeight: 'normal',
        },
        objEllipsis
    );
    const { line, widthContainer, sizeText, fontWeight } = obj;

    if (!content) {
        return null;
    }

    const getTextWidth = (str: string) => {
        if (typeof document === 'undefined') {
            return 0;
        }
        const text = document.createElement('span');
        document.body.appendChild(text);

        text.style.fontSize = sizeText;
        text.style.fontWeight = fontWeight;
        text.style.height = 'auto';
        text.style.width = 'auto';
        text.style.position = 'fixed';
        text.style.zIndex = '2';
        text.style.top = '0px';
        text.style.whiteSpace = 'nowrap';
        text.innerHTML = str;

        const width = text.getBoundingClientRect().width;
        document.body.removeChild(text);

        return width;
    };

    const getTextInLine = (
        content: string,
        arr: string[],
        spaceSize: number
    ) => {
        const arrDes = content.split(' ');
        let textInline = '';
        let length = 0;
        for (const text of arrDes) {
            length = length + getTextWidth(text) + spaceSize;
            if (length > widthContainer) {
                if (length - spaceSize < widthContainer) {
                    textInline += text;
                }
                break;
            }
            textInline += text + ' ';
        }
        arr.push(textInline.trim());
        const result = content.replace(textInline.trim(), '');

        return result.trim();
    };

    const truncateText = (content: string, line: number, spaceSize: number) => {
        let arr: string[] = [];
        return spliceLine(content, arr, line, spaceSize);
    };

    function spliceLine(
        content: string,
        arr: string[],
        line: number,
        spaceSize: number
    ) {
        if (content.length > 0 && line > 0) {
            const anotherText = getTextInLine(content, arr, spaceSize);
            return spliceLine(anotherText, arr, line - 1, spaceSize);
        } else {
            return arr;
        }
    }

    const renderContent = () => {
        const spaceSize = getTextWidth('&nbsp;');
        const arr = truncateText(content, line + 1, spaceSize);
        if (arr.length <= line) {
            return <>{content}</>;
        }

        const arrEleWord = arr
            ?.slice(0, line)
            ?.map((text: string, index: number) => {
                let _text = text.trim();
                if (index === line - 1) {
                    const lastRowWidth = getTextWidth(_text + '...');
                    if (lastRowWidth > widthContainer) {
                        _text =
                            _text.substring(0, _text.lastIndexOf(' ')) + '...';
                    } else {
                        _text = _text + '...';
                    }
                }
                return (
                    <span className="inline-block" key={`key.${index}`}>
                        {_text}
                    </span>
                );
            });

        return <>{arrEleWord}</>;
    };

    return <>{renderContent()}</>;
}

export default memo(TruncateText);
